import { log } from '@/utils/common';
import { http } from '../utils/http';

async function getYoutubeList() {
  log('snsApi::getYoutubeListTest');
  try {
    const { data } = await http.get('/youtube?brandType=BOTALAB');
    return data;
  } catch (e) {
    log('snsApi::getYoutubeListTest', e);
    return {
      error: 'error',
    };
  }
}
async function getInstaList(num) {
  log('snsApi::getinstaList');
  try {
    const params = {
      brandType: 'BOTALAB',
      count: num,
    };
    const { data } = await http.get('/instagram', params);

    return data;
  } catch (e) {
    log('snsApi::getinstaList', e);
    return {
      error: 'error',
    };
  }
}

async function getBotalabBrandFilms() {
  try {
    const { data } = await http.get('/brand-film?brandType=BOTALAB');
    log('getBotalabBrandFilms', data);
    return data;
  } catch (e) {
    log('YoutubeApi::getYoutubeListTest', e);
    return {
      error: 'error',
    };
  }
}
async function updateBotalabFilmReadCount(filmId) {
  try {
    log('updateBotalabFilmReadCount', filmId);
    await http.patch(`/brand-film/${filmId}/read-count`);
  } catch (e) {
    log('snsApi::updateBotalabFilmReadCount', e);
  }
}
async function getMainVideo(){
  log('snsApi::getMainVideo');
  try {
    const params = {
      brandType: 'BOTALAB',
    };
    const { data } = await http.get('/main-videos', params);
    return data;
  } catch (e) {
    log('snsApi::getMainVideo', e);
    return {
      error: 'error',
    };
  }
}

export default {
  getYoutubeList,
  getBotalabBrandFilms,
  getInstaList,
  updateBotalabFilmReadCount,
  getMainVideo,
};
